import * as PIXI from 'pixi.js'
import Matter from 'matter-js'
import { pixiApp } from './initializePixi.js'
import {
  changeLinesNumber,
  // createPoints,
  createPointsAndBoxes, destroyAllBoxes, destroyAllPoints, setupPayoutText
} from './pointAndBox.js'
import { createBall, destroyAllBalls } from './ball.js'
import { destroyMatterWorld, matterEngineIgnition, setupMatterJS } from './appMatter.js'
import { getFPS, setTickerRun } from './gameLogic.js'
import { isCompactPlinkoTheme } from '../../theme/plinkoTheme.config'
// import { data } from './dataForBall.js'
// import { secondIndex } from './utility.js'
import { settings } from '../settings.js'
// import { dispatching } from '../bridge.js'
// import { dataForBall } from '../pixiHelper.js'
// import { useSelector } from 'react-redux'
// import { useEffect } from 'react'
// import { dataEight } from '../dataEight.js'
export let deviceFPS = 0
let uiCreated = false
// const lineNum = 8
// const dataAnalysis = []
const dataAnalysis = [
  [[], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
  [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]
]

const matterAssets = {
  engine: Matter.Engine.create(),
  world: null,
  ball: null,
  ball2: null
}

const containers = {
  rootContainer: new PIXI.Container(),
  pointsContainer: new PIXI.Container(),
  backgroundContainer: new PIXI.Container(),
  ballContainer: new PIXI.Container()
}

const assets = {
  points: [],
  activeBalls: [],
  boxes: []
}

let _lineNum = settings.lines.initialNumber
export const linesNum = {
  get: () => _lineNum,
  set: (newLineNum) => { _lineNum = newLineNum }
}

function runTicker () {
  matterEngineIgnition()
  setTickerRun(true)
}

function createUI () {
  setupMatterJS()
  setupContiners()
  // instantiatePoints()
  createPointsAndBoxes()
  runTicker()
  uiCreated = true
  deviceFPS = getFPS()
}

function setupContiners () {
  if (!containers.rootContainer || containers.rootContainer.destroyed) {
    containers.rootContainer = new PIXI.Container()
  } else {
    containers.rootContainer.removeChildren()
  }

  if (!containers.pointsContainer || containers.pointsContainer.destroyed) {
    containers.pointsContainer = new PIXI.Container()
  } else {
    containers.pointsContainer.removeChildren()
  }

  if (!containers.backgroundContainer || containers.backgroundContainer.destroyed) {
    containers.backgroundContainer = new PIXI.Container()
  } else {
    containers.backgroundContainer.removeChildren()
  }

  if (!containers.ballContainer || containers.ballContainer.destroyed) {
    containers.ballContainer = new PIXI.Container()
  } else {
    containers.ballContainer.removeChildren()
  }

  pixiApp.app.stage.addChild(containers.rootContainer)
  setupBackground()
  containers.rootContainer.addChild(containers.ballContainer)
  setupTitle()
  containers.rootContainer.addChild(containers.pointsContainer)
}
function setupTitle () {
  if (isCompactPlinkoTheme()) {
    return
  }

  const banner = new PIXI.Sprite(PIXI.Assets.get('banner'))
  banner.y = -90
  banner.x = 320
  banner.scale.set(0.9)
  const title = new PIXI.Sprite(PIXI.Assets.get('title'))
  title.x = banner.width / 2 - (title.width / 2 - 60)
  title.y = banner.height / 2
  banner.addChild(title)
  containers.rootContainer.addChild(banner)
}
function setupBackground () {
  if (isCompactPlinkoTheme()) {
    // Keep canvas transparent in theme-two so it blends with the page background
    return
  }

  const frame = new PIXI.Sprite(PIXI.Assets.get('frame'))
  frame.y = 150
  frame.scale.set(1.7)
  const bar = new PIXI.Sprite(PIXI.Assets.get('bar'))
  bar.x = 18
  bar.y = frame.height - bar.height / 4 + 60
  bar.scale.set(0.807)

  const incirc = new PIXI.Sprite(PIXI.Assets.get('incircle'))
  incirc.x =  frame.width / 2 - (incirc.width / 2) - 50
  incirc.y = 70
  incirc.scale.set(1)
  const outcirc = new PIXI.Sprite(PIXI.Assets.get('outcircle'))
  outcirc.x =  frame.width / 2 - (incirc.width / 2) - 75
  outcirc.y = -55
  outcirc.scale.set(1)

  containers.backgroundContainer.addChild(frame, bar , outcirc , incirc)
  containers.rootContainer.addChild(containers.backgroundContainer)
}

// function setupBackground () {
//   const frame = new PIXI.Sprite(PIXI.Assets.get('frame'))
//   frame.y = 150
//   frame.scale.set(1.7)
//   const bar = new PIXI.Sprite(PIXI.Assets.get('bar'))
//   bar.x = 18
//   bar.y = frame.height - bar.height / 4
//   bar.scale.set(0.8)
//   containers.backgroundContainer.addChild(frame, bar)
//   containers.rootContainer.addChild(containers.backgroundContainer)
// }

function simulateBallCreation (dataForBall, winningSlot, dropDetails) {
  console.log('box text', assets.boxes[winningSlot].boxText.text)
  // const ballPathFirstArray = linesNum.get() - settings.lines.initialNumber
  // const ballPathThirdArray = secondIndex(data[ballPathFirstArray][winningSlot])
  console.log('winning slot ', winningSlot)
  console.log('path ', dropDetails)
  createPath(dropDetails, dataForBall)
}
let ballPath = []
let ballStartPos = 1

function createPath (dropDetails, dataForBall) {
  const digitsString = dropDetails.toString()

  // Create an array to store the digits
  const pathArray = []

  // Iterate over each character in the string
  for (let i = 0; i < digitsString.length; i++) {
    // Convert each character back to a number and add it to the array
    pathArray.push(parseInt(digitsString[i]))
  }
  // console.log("path ar", dropDetails)
  // Return the array of digits
  generatePath(pathArray, dataForBall)
}

function generatePath (pathArray, dataForBall) {
  const rand = Math.round(Math.random() * 2)
  if (rand === 0) {
    ballStartPos = 0
    for (let i = 0; i < pathArray.length; i++) {
      if (pathArray[i] === 0) {
        pathArray[i] = 1
        break
      }
    }
    // console.log("path ar 2", pathArray)
    // console.log("path ar 1", pathArray)
  } else if (rand === 2) {
    ballStartPos = 2
    for (let i = 0; i < pathArray.length; i++) {
      if (pathArray[i] === 1) {
        pathArray[i] = 0
        break
      }
    }
    // console.log("path ar 2", pathArray)
  } else if (rand === 1) {
    ballStartPos = 1
    // console.log("path ar 2", pathArray)
  }
  createBall(dataForBall, 0 , pathArray, ballStartPos)
}

export const faultyArray = []
// const liness = 15
export const testIndex = 0
// function testSimulation () {
//   simulateBallCreation(0, testIndex)
// }

export {
  createUI,
  uiCreated,
  dataAnalysis,
  matterAssets,
  containers,
  assets,
  destroyAllBalls,
  destroyAllPoints,
  destroyAllBoxes,
  destroyMatterWorld,
  simulateBallCreation,
  setupPayoutText,
  changeLinesNumber
}
